<template>
  <v-row justify="center">
    <v-expansion-panels accordion>
      <v-expansion-panel>
        <v-expansion-panel-header rounded="xl">تم شب</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card-text>
            <v-card-title>لطفا طیف های رنگی خود را انتخاب کنید</v-card-title>
            <v-card-subtitle>طیف رنگی شب</v-card-subtitle>
          </v-card-text>
          <v-card elevation="0" class="d-flex">
            <v-col cols="6">
              <v-card-subtitle>رنگ زمینه</v-card-subtitle>
              <colorPicker
                v-model="value['dark'].backgroundColor"
                :color="value['dark'].backgroundColor"
                size="150px"
              />
              <v-card-subtitle>رنگ مولفه ها (کامپوننتها*)</v-card-subtitle>
              <colorPicker
                v-model="value['dark'].componentsColor"
                :color="value['dark'].componentsColor"
                size="150px"
              />
              <v-card-subtitle>رنگ آیکون ها</v-card-subtitle>
              <colorPicker
                v-model="value['dark'].iconColor"
                :color="value['dark'].iconColor"
                size="150px"
              />
              <v-card-subtitle>رنگ متن ها</v-card-subtitle>
              <colorPicker
                v-model="value['dark'].textColor"
                :color="value['dark'].text"
                size="150px"
              />
            </v-col>

            <v-col cols="6">
              <ul
                :style="{
                  width: '150px',
                  height: '340px',
                  borderRadius: '10px',
                  margin: '0',
                  padding: '0',
                  margin: '1rem',
                  cursor: 'pointer',
                  position: 'relative',
                  boxShadow: '0 0 8px rgba(0,0,0,.4)',
                }"
              >
                <li
                  :style="{
                    listStyle: 'none',
                    width: '100%',
                    height: '25%',
                    background: value['dark'].backgroundColor,
                  }"
                ></li>
                <li
                  :style="{
                    listStyle: 'none',
                    width: '100%',
                    height: '25%',
                    background: value['dark'].componentsColor,
                  }"
                ></li>
                <li
                  :style="{
                    listStyle: 'none',
                    width: '100%',
                    height: '25%',
                    background: value['dark'].iconColor,
                  }"
                ></li>
                <li
                  :style="{
                    listStyle: 'none',
                    width: '100%',
                    height: '25%',
                    background: value['dark'].textColor,
                  }"
                ></li>
              </ul>
            </v-col>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>تم روز </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card-title>لطفا طیف های رنگی خود را انتخاب کنید</v-card-title>
          <v-card-subtitle>طیف رنگی روز</v-card-subtitle>
          <v-card elevation="0" class="d-flex">
            <v-col cols="6">
              <v-card-subtitle>رنگ زمینه</v-card-subtitle>
              <colorPicker
                v-model="value['light'].backgroundColor"
                :color="value['light'].backgroundColor"
                size="150px"
              />
              <v-card-subtitle>رنگ مولفه ها (کامپوننتها*)</v-card-subtitle>
              <colorPicker
                v-model="value['light'].componentsColor"
                :color="value['light'].componentsColor"
                size="150px"
              />
              <v-card-subtitle>رنگ آیکون ها</v-card-subtitle>
              <colorPicker
                v-model="value['light'].iconColor"
                :color="value['light'].iconColor"
                size="150px"
              />
              <v-card-subtitle>رنگ متن ها</v-card-subtitle>
              <colorPicker
                v-model="value['light'].textColor"
                :color="value['light'].text"
                size="150px"
              />
            </v-col>

            <v-col cols="6">
              <ul
                :style="{
                  width: '150px',
                  height: '340px',
                  borderRadius: '10px',
                  margin: '0',
                  padding: '0',
                  margin: '1rem',
                  cursor: 'pointer',
                  position: 'relative',
                  boxShadow: '0 0 8px rgba(0,0,0,.4)',
                }"
              >
                <li
                  :style="{
                    listStyle: 'none',
                    width: '100%',
                    height: '25%',
                    background: value['light'].backgroundColor,
                  }"
                ></li>
                <li
                  :style="{
                    listStyle: 'none',
                    width: '100%',
                    height: '25%',
                    background: value['light'].componentsColor,
                  }"
                ></li>
                <li
                  :style="{
                    listStyle: 'none',
                    width: '100%',
                    height: '25%',
                    background: value['light'].iconColor,
                  }"
                ></li>
                <li
                  :style="{
                    listStyle: 'none',
                    width: '100%',
                    height: '25%',
                    background: value['light'].textColor,
                  }"
                ></li>
              </ul>
            </v-col>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
</template>

<script>
import colorPicker from "../../../qrland/components/colorPicker.vue";
export default {
  props: {
    value: [Object, Array],
  },
  components: { colorPicker },
};
</script>

<style></style>
